// Projects Array
const projects = [
  {
      name: "Audiophile E-commerce Website", 
      gitHubLink: "https://github.com/yahia997/E-commerce-website-With-React.js", 
      link: "https://e-comm-p1.netlify.app/", 
      img: "Audiopile.png"
  },
  {
      name: "Problem Solving Platform", 
      gitHubLink: "https://github.com/yahia997/Massive-Problem-Solving-Platform-arab-expert-", 
      link: "https://arab-expert.cyclic.app/", 
      img: "arabexpert.png"
  },
  {
      name: "Chat App", 
      gitHubLink: "https://github.com/yahia997/Chat-app", 
      link: "https://chat-app-byup.onrender.com/", 
      img: "chatapp.png"
  },
  {
      name: "Stark", 
      gitHubLink: "https://github.com/yahia997/Stark-home-page", 
      link: "https://yahia997.github.io/Stark-home-page/", 
      img: "starkcopy.png"
  },
  {
      name: "Pomodoro App", 
      gitHubLink: "https://github.com/yahia997/Pomodoro-App", 
      link: "https://yahia997.github.io/Pomodoro-App/", 
      img: "pomodoroapp.png"
  },
  {
      name: "Books Search Website With Google API", 
      gitHubLink: "https://github.com/yahia997/Book-Store/tree/master/static", 
      link: "https://books-store-project.netlify.app/", 
      img: "bookstore.png"
  },
  {
      name: "E-commerce-product-page", 
      gitHubLink: "https://github.com/yahia997/E-commerce-product-page", 
      link: "https://yahia997.github.io/E-commerce-product-page/", 
      img: "Screenshot (2).png"
  },
  {
      name: "Deplacemaison-Home-Page", 
      gitHubLink: "https://github.com/yahia997/Deplacemaison-Home-Page", 
      link: "https://deplacemaison.netlify.app/", 
      img: "deplacemason.png"
  },
  {
      name: "Memorize New Words", 
      gitHubLink: "", 
      link: "https://new-word.herokuapp.com/", 
      img: "newword.png"
  },
  {
      name: "Myteam landing page", 
      gitHubLink: "https://github.com/yahia997/myteam-multi-page-website", 
      link: "https://yahia997.github.io/myteam-multi-page-website/", 
      img: "Screenshot (4).png"
  },
  {
      name: "Newsletter-sign-up-form-with-success-message", 
      gitHubLink: "https://github.com/yahia997/Newsletter-sign-up-form-with-success-message", 
      link: "https://yahia997.github.io/Newsletter-sign-up-form-with-success-message/", 
      img: "Screenshot (1).png"
  },
  {
      name: "Password Generator", 
      gitHubLink: "https://github.com/yahia997/Passwrod-Generator", 
      link: "https://yahia997.github.io/Passwrod-Generator/", 
      img: "Screenshot (3).png"
  },
  {
      name: "Simple Game", 
      gitHubLink: "https://github.com/yahia997/Simple-Game", 
      link: "https://yahia997.github.io/Simple-Game/", 
      img: "simplegame.png"
  },
  {
      name: "Simple Photo Editor", 
      gitHubLink: "https://github.com/yahia997/Simple-Photo-Editor", 
      link: "https://simple-photo-shop.netlify.app/", 
      img: "photoeditor.png"
  },
  {
      name: "Calculator wihtout eval", 
      gitHubLink: "https://github.com/yahia997/Calculator-without-eval", 
      link: "https://calc-yahia.netlify.app/", 
      img: "calc.png"
  },
]

// Skills Array
const mySkills = [
  {name: "React", progress: 70},
  {name: "Javascript/Node", progress: 65},
  {name: "Css/Css3", progress: 80},
  {name: "Html/Html5", progress: 75 },
  {name: "Express", progress: 40 },
  {name: "MongoDB", progress: 30 },
]

export {mySkills, projects};